if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.section = {
          settings: JSON.parse(this.getAttribute('data-section-settings') || '{}')
        };
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.prepareGalleryVideos();
        this.elements.thumbnails.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-target] button');
            if (!button || !this.elements.thumbnails.contains(button)) return;
            const mediaToSwitch = button.closest('[data-target]');
            if (!mediaToSwitch?.dataset?.target) return;
            event.preventDefault();
            event.stopPropagation();
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          },
          true
        );
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.playActiveMedia(event.detail.currentElement);
      }

      prepareGalleryVideos() {
        this.querySelectorAll('.product-media-container.media-type-video video').forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.autoplay = false;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.removeAttribute('autoplay');
          video.preload = 'none';
        });
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          if (!this.section?.settings?.no_scroll) {
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        /* OWNER FIX 2026-08-23: "click the video, click it again, click it again -
           they play and go again." ROOT CAUSE FOUND: this stock Dawn method ran on
           EVERY setActiveMedia/onSlideChanged call (every thumbnail tap, every swipe,
           even re-selecting the slide already showing) and unconditionally forced
           video.autoplay = true + called video.load() (when readyState 0) + video.play(),
           completely independent of and unsynchronized with the gallery's OWN video
           controller in sections/main-product.liquid (ensureAttrs/tryAutoplay), which
           already deliberately turned autoplay OFF for performance (OWNER FIX
           2026-07-30/08-23: this clip is ~70% of page weight) and carries a WeakSet
           once-only load() guard plus a "only resume if WE paused it" flag
           (__hrAutoResume) specifically to kill this exact restart.
           Two uncoordinated controllers fighting on the same event is what produced
           the restart: reproduced live with instrumented play/pause/load listeners -
           this method's forced video.play() and the other controller's active-state
           pause raced on the same activation, both firing within the same tick
           (logged: PLAY() CALLED t=0.00 -> "play" -> "pause", back to back). This
           method's own unguarded `if (readyState===0) load()` (no once-only tracking
           at all, unlike the other controller's isInit()/markInit() WeakSet) is also
           what produced "sometimes it doesn't load instantly" - it could re-fire
           load() on a slide that had already started buffering under the other
           controller's watch.
           FIX: stop this stock handler from touching video playback state at all.
           The product gallery's own controller (main-product.liquid) is the single
           owner of mute/autoplay/load/play/pause for its video slide, driven off the
           same is-active class change via its MutationObserver. Only keep the
           "pause videos that scrolled out of the active item" cleanup, which is
           harmless and does not fight with anything. */
        this.querySelectorAll('.product-media-container.media-type-video video').forEach((galleryVideo) => {
          if (!activeItem.contains(galleryVideo)) galleryVideo.pause();
        });

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Some mobile slider layers stop thumbnail clicks before they reach the
// custom element. Capture the click at document level and hand it to the
// nearest gallery so every visible thumbnail remains usable.
if (!window.__hrGalleryThumbCapture) {
  window.__hrGalleryThumbCapture = true;
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const button = target?.closest?.('[id^="GalleryThumbnails"] [data-target] button');
      if (!button) return;
      const mediaToSwitch = button.closest('[data-target]');
      const gallery = button.closest('media-gallery');
      if (!gallery || !mediaToSwitch?.dataset?.target || typeof gallery.setActiveMedia !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      gallery.setActiveMedia(mediaToSwitch.dataset.target, false);
    },
    true
  );
}
